import { render, staticRenderFns } from "./DefaultTerms.vue?vue&type=template&id=70ab771e"
import script from "./DefaultTerms.vue?vue&type=script&lang=js"
export * from "./DefaultTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports